module.exports = __webpack_public_path__ + "static/img/011.60b188e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/011.jpg
// module id = TKb9
// module chunks = 0